import url from 'url-polyfill';

export default function appUrl(path) {
  if (!path) {
    return window.location.origin;
  }

  if (!window.URL) {
    window.URL = url;
  }

  if (path[0] !== '/') {
    throw new Error('appUrl: path must be a full path');
  }

  return new URL(path, window.location).href;
}
